// extracted by mini-css-extract-plugin
module.exports = {"container":"SchoolFeedList_container__wp6qZ"};